import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@muzly/lib/utils';

/**
 * 시안의 흰 카드 — `#fafafa` 바탕 위 흰색 · 라운드 24 · 그림자 `sd1`(테두리 없음).
 * 홈·결과 상세·MY 가 같은 모양을 쓴다. 테두리 카드(`border-border`)는 시안에 없다.
 */
export const Card = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('rounded-[24px] bg-white shadow-card', className)}
    {...props}
  />
);

/**
 * 목록 카드(시안 `menu card`·`language list`·`faq list`) — 행을 세로로 쌓고 사이에 1px
 * 구분선을 긋는다. 좌우 여백(20px)은 카드가 갖고, 행은 자기 위아래 여백만 정한다 — 구분선이
 * 카드 안쪽 폭으로 선다.
 */
export const ListCard = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <Card
    className={cn('divide-y divide-bk-50 px-5 py-1', className)}
    {...props}
  />
);

/**
 * 섹션 머리 카드 — 제목(20px SemiBold)과 오른쪽 부속(기간 셀렉트·날짜 링크)이 한 줄.
 * 시안은 섹션 본문(점수·차트·타일)을 카드 **밖** `#fafafa` 위에 두고, 제목만 카드로 띄운다.
 */
export const SectionHeadCard = ({
  title,
  right,
  size = 'lg',
  className,
}: {
  title: ReactNode;
  right?: ReactNode;
  /** 홈은 20px, 결과 상세 안의 소제목은 18px. */
  size?: 'lg' | 'md';
  className?: string;
}) => (
  <Card className={cn('flex items-center gap-2 px-5 py-[18px]', className)}>
    <h2
      className={cn(
        'min-w-0 flex-1 font-semibold tracking-[-0.1px] text-bk-900',
        size === 'lg' ? 'text-xl' : 'text-lg',
      )}
    >
      {title}
    </h2>
    {right}
  </Card>
);
